import { MainAPiServiceService } from '@_services/main-api-service.service';
import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-property-connections',
  templateUrl: './property-connections.component.html',
  styleUrls: ['./property-connections.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PropertyConnectionsComponent implements OnDestroy {
  @Input() MatterPropertyDetailsForm: FormGroup;
  @Input() errorWarningData: any;
  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() testBool;
  sub: Subscription;
  connectionType: any[] = [];
  filteredOptions: { [key: string]: any[] } = {};

  private connectionFields = [
    'ELECTRICITYCONNECTIONSTATUS',
    'GASCONNECTIONSTATUS',
    'WATERCONNECTIONSTATUS',
    'SEWERAGECONNECTIONSTATUS',
    'TELEPHONECONNECTIONSTATUS',
    'INTERNETCONNECTIONSTATUS',
  ];

  constructor(
    public datepipe: DatePipe,
    private _mainAPiServiceService: MainAPiServiceService,
  ) {
    let connectionTypesLookups = localStorage.getItem('connection_type');
    if (connectionTypesLookups && connectionTypesLookups != 'null') {
      this.connectionType = JSON.parse(connectionTypesLookups);
      this.initializeFilteredOptions();
    } else {
      this.sub = this._mainAPiServiceService
        .getSetData({ Action: 'getdata', Filters: { LookupType: 'Connection Status' } }, 'lookup')
        .subscribe((responses) => {
          if (responses.CODE === 200 && responses.STATUS === 'success') {
            this.connectionType = responses.DATA.LOOKUPS;
            localStorage.setItem('connection_type', JSON.stringify(responses.DATA.LOOKUPS));
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  CommanDatePickerClick(type: string, event: MatDatepickerInputEvent<Date>, formfield: any) {
    this.MatterPropertyDetailsForm.controls[formfield].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
  }

  private initializeFilteredOptions(): void {
    for (const field of this.connectionFields) {
      this.filteredOptions[field] = [...this.connectionType];
    }
  }

  onDetectChanges(event: any, controlName: string) {
    const inputValue = (event.target.value || '').toLowerCase();

    this.filteredOptions[controlName] = this.connectionType.filter((option) =>
      option.LOOKUPFULLVALUE.toLowerCase().includes(inputValue),
    );
  }

  /** When user selects from autocomplete */
  onOptionSelected(selected: any, fieldName: string) {
    this.MatterPropertyDetailsForm.get(fieldName)?.setValue(selected);
  }

  /** When user leaves input field */
  onBlur(value: string, fieldName: string) {
    const match = this.connectionType.find(
      (x) => x.LOOKUPFULLVALUE.toLowerCase() === value.trim().toLowerCase(),
    );
    if (match) {
      this.MatterPropertyDetailsForm.get(fieldName)?.setValue(match.LOOKUPGUID);
    } else {
      this.MatterPropertyDetailsForm.get(fieldName)?.setValue(value);
    }
  }

  /** Display correct text in input field */
  getDisplayValue(fieldName: string): string {
    const guid = this.MatterPropertyDetailsForm.get(fieldName)?.value;
    const match = this.connectionType.find((x) => x.LOOKUPGUID === guid);
    return match ? match.LOOKUPFULLVALUE : guid || '';
  }

  showAllOptions(controlName: string) {
    this.filteredOptions[controlName] = [...this.connectionType];
  }
}
